"use client";

import { dynamicChart } from "@/components/charts/dynamicChart";

export type { RestrictionEvent } from "./RestrictionTimelineChart.impl";

export const RestrictionTimelineChart = dynamicChart(
  () =>
    import("./RestrictionTimelineChart.impl").then(
      (m) => m.RestrictionTimelineChart,
    ),
  224,
);
